export const overview = {
  total_events: 24,
  total_booked: "17",
  total_ongoing: "0",
  total_cancelled: "4",
  total_hold: "0",
  total_revenue: "145000.00",
  lost_revenue: "0.00",
};

export const eventTypes = [
  { event_type: "Wedding", total_events: 1, booked: "0", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Ring Ceremony", total_events: 6, booked: "1", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Reception", total_events: 4, booked: "2", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Other Social", total_events: 1, booked: "1", ongoing: "0", cancelled: "0", revenue: "100000.00" },
  { event_type: "Nikkah", total_events: 5, booked: "3", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Corporate", total_events: 0, booked: "0", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Birthday", total_events: 3, booked: "1", ongoing: "0", cancelled: "0", revenue: "0.00" },
  { event_type: "Anniversary", total_events: 4, booked: "2", ongoing: "0", cancelled: "0", revenue: "45000.00" },
];

export const cancellationSummary = { cancellation_count: 4, lost_revenue: "0.00", affected_guests: "40" };

export const cancellationReasons = [
  { cancellation_reason: "Guest Not Responding", event_count: 2, lost_revenue: "0.00" },
  { cancellation_reason: "Location unavailable", event_count: 2, lost_revenue: "0.00" },
  { cancellation_reason: "Budget is Low", event_count: 0, lost_revenue: "0.00" },
  { cancellation_reason: "Booked somewhere else", event_count: 0, lost_revenue: "0.00" },
  { cancellation_reason: "Cancelled future date", event_count: 0, lost_revenue: "0.00" },
  { cancellation_reason: "Duplicate", event_count: 0, lost_revenue: "0.00" },
];

export const guestStats = { guest_visit_count: 20, event_count: 20, total_guests: "101769" };

export const venues = [
  { venue_name: "test 2", venue_type: "OUTDOOR", seating_capacity: "2000", floating_capacity: 3000, total_leads: 5, booked: "2", cancelled: "0", ongoing: "0", hold: "0", revenue: "145000.00" },
  { venue_name: "test", venue_type: null as string | null, seating_capacity: "0", floating_capacity: 0, total_leads: 15, booked: "7", cancelled: "0", ongoing: "0", hold: "0", revenue: "0.00" },
];

export const fmtCurrency = (v: string | number) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(v));
export const fmtNum = (v: string | number) => new Intl.NumberFormat("en-IN").format(Number(v));